export const handleKeySpaceMenuOpen = (state) => {
  // TODO
  // await Menu.selectCurrent()
  return state
}
